import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiFetch } from "../APIClient";
import {
  GenerateTestUsersRequestDto,
  GenerateTestUsersResponseDto,
} from "../generated/generatedTypes";
import { getApiErrorMessage } from "../getApiErrorMessage";

const generateTestUsers = async ({
  count,
}: GenerateTestUsersRequestDto): Promise<GenerateTestUsersResponseDto> => {
  const response = await apiFetch("api/admin/test-data/users", {
    method: "POST",
    body: JSON.stringify({ count }),
  });

  if (!response.ok) {
    throw new Error(await getApiErrorMessage(response));
  }

  return response.json();
};

export const useGenerateTestUsers = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: generateTestUsers,
    // Returning the promise keeps the mutation pending until the refetch finishes.
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["reservation-requests"] }),
  });
};
